<template>
  <div ref="max-racing-game" class="max-racing-game">
    <div class="max-racing-no-bet">
      <max-racing-number
        :game="game"
        :game-data="gameData"
        :draw-result="drawResult"
        :disallow-betting="disallowBetting"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
      />
    </div>

    <div
      ref="max-racing-disallow-betting-section"
      class="max-racing-disallow-betting-section"
      v-if="displayDisallowSection"
    >
      <Row class="max-racing-disallow-betting" type="flex" justify="center" align="middle">
        <Col>
          <div>{{ $t("general.no_more_bet") }}</div>
        </Col>
      </Row>
    </div>

    <div ref="max-racing-dark-bg" class="max-racing-dark-bg"></div>

    <div
      ref="animation-section"
      class="max-racing-animation-section"
      :class="{ hide: displayStopAnimationSection }"
    >
      <img ref="roadMove" class="roadImg roadMove" src=https://i.ibb.co/FH9MV9z/roadv6.png>
      <div ref="racing-countdown" class="racing-countdown">{{racingCountdown}}</div>
      <div class="animation-wrapper">
        <!-- <div> <img class="upup" src="../../assets/images/max-racing/grid.png" /></div> -->
        <div class="race-track-one">
          <div ref="car-indicator-1" class="car-indicator" :style="carIndicatorStyle">
            <span ref="indicator-one" class="indicator-number indicator-one">1</span>
          </div>
          <div class="car-wrap" ref="car1">
            <img class="car carOne" src="../../assets/images/max-racing/car-1.png" />
            <div class="test">1</div>
          </div>
        </div>
        <div class="race-track-two">
          <div ref="car-indicator-2" class="car-indicator" :style="carIndicatorStyle">
            <span ref="indicator-two" class="indicator-number indicator-two">2</span>
          </div>
          <div class="car-wrap" ref="car2">
            <img class="car carTwo" src="../../assets/images/max-racing/car-2.png" />
            <div class="test">2</div>
          </div>
        </div>
        <div class="race-track-three">
          <div ref="car-indicator-3" class="car-indicator" :style="carIndicatorStyle">
            <span ref="indicator-three" class="indicator-number indicator-three">3</span>
          </div>
          <div class="car-wrap" ref="car3">
            <img class="car carThree" src="../../assets/images/max-racing/car-3.png" />
            <div class="test">3</div>
          </div>
        </div>
        <div class="race-track-four">
          <div ref="car-indicator-4" class="car-indicator" :style="carIndicatorStyle">
            <span ref="indicator-four" class="indicator-number indicator-four">4</span>
          </div>
          <div class="car-wrap" ref="car4">
            <img class="car carFour" src="../../assets/images/max-racing/car-1.png" />
            <div class="test">4</div>
          </div>
        </div>
        <div class="race-track-five">
          <div ref="car-indicator-5" class="car-indicator" :style="carIndicatorStyle">
            <span ref="indicator-five" class="indicator-number indicator-five">5</span>
          </div>
          <div class="car-wrap" ref="car5">
            <img class="car carFive" src="../../assets/images/max-racing/car-4.png" />
            <div class="test">5</div>
          </div>
        </div>
        <div class="race-track-six">
          <div ref="car-indicator-6" class="car-indicator" :style="carIndicatorStyle">
            <span ref="indicator-six" class="indicator-number indicator-six">6</span>
          </div>
          <div class="car-wrap" ref="car6">
            <img class="car carSix" src="../../assets/images/max-racing/car-5.png" />
            <div class="test">6</div>
          </div>
        </div>
        <div class="race-track-seven">
          <div ref="car-indicator-7" class="car-indicator" :style="carIndicatorStyle">
            <span ref="indicator-seven" class="indicator-number indicator-seven">7</span>
          </div>
          <div class="car-wrap" ref="car7">
            <img class="car carSeven" src="../../assets/images/max-racing/car-2.png" />
            <div class="test">7</div>
          </div>
        </div>
        <div class="race-track-eight">
          <div ref="car-indicator-8" class="car-indicator" :style="carIndicatorStyle">
            <span ref="indicator-eight" class="indicator-number indicator-eight">8</span>
          </div>
          <div class="car-wrap" ref="car8">
            <img class="car carEight" src="../../assets/images/max-racing/car-4.png" />
            <div class="test">8</div>
          </div>
        </div>
        <div class="race-track-nine">
          <div ref="car-indicator-9" class="car-indicator" :style="carIndicatorStyle">
            <span ref="indicator-nine" class="indicator-number indicator-nine">9</span>
          </div>
          <div class="car-wrap" ref="car9">
            <img class="car carNine" src="../../assets/images/max-racing/car-5.png" />
            <div class="test">9</div>
          </div>
        </div>
        <div class="race-track-ten">
          <div ref="car-indicator-10" class="car-indicator" :style="carIndicatorStyle">
            <span ref="indicator-ten" class="indicator-number indicator-ten">10</span>
          </div>
          <div class="car-wrap" ref="car10">
            <img class="car carTen" src="../../assets/images/max-racing/car-3.png" />
            <div class="test">10</div>
          </div>
        </div>
      </div>
    </div>
    <div
      ref="animation-section-result"
      class="max-racing-animation-section-result"
      :class="{ hide: displayStopAnimationSection }"
    >
      <div class="section-result-wrapper">
        <div class="animation-result-title">{{$t("maxracing.Race_result")}}</div>
        <div class="trophy-wrapper">
          <div class="trophy-image">
            <img class="trophy champion" src="../../assets/images/max-racing/winner-hero.png" />
          </div>
          <div class="champion-car">{{this.winners[0]}}</div>
          <div class="runnerup-car">{{this.winners[1]}}</div>
        </div>
        <div class="rounds-wrapper">
          <div class="rounds">
            {{ this.winners[0] }}
            <img
              class="star-image"
              src="../../assets/images/max-racing/first-place.png"
            />
          </div>
          <div class="rounds">
            {{ this.winners[1] }}
            <img
              class="star-image"
              src="../../assets/images/max-racing/second-place.png"
            />
          </div>
          <div class="rounds" v-for="items in this.winners.slice(2,10)" :key="items">{{ items }}</div>
        </div>
        <div class="champion-result-container">
          <div class="trophy-result-image">
            <div>
              <img
                class="trophy champion-result-image"
                src="../../assets/images/max-racing/first-trophy.png"
              />
            </div>
          </div>
          <div class="champion-result-number">{{this.winners[0]}}</div>
          <div class="champion-result">{{ champBS }}</div>
          <div class="champion-result">{{ champOE }}</div>
        </div>
        <div class="champion-runner-result-container">
          <div class="trophy-result-image">
            <img
              class="trophy champion-result-image"
              src="../../assets/images/max-racing/first-second-trophy.png"
            />
          </div>
          <div class="champion-result-number">{{sumChampionRunnerup}}</div>
          <div class="champion-runner-result">{{champRunBS}}</div>
          <div class="champion-runner-result">{{champRunOE}}</div>
          <div class="champion-runner-result">{{ group }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { snakeCase } from "change-case";
import { random } from "lodash";
import { TweenLite, TimelineLite, TimelineMax, TweenMax } from "gsap";
import { Row, Button, Timeline } from "iview";

import MaxRacingNumber from "./max-racing-game/MaxRacingNumber";
import EventBus from "../../configs/event-bus";
import { race } from "q";

export default {
  props: [
    "game",
    "gameData",
    "countDown",
    "drawResult",
    "showDrawingAnimation",
    "disallowBetting",
    "displayDisallowSection",
    "minutesString",
    "secondsString",
    "game-on-animation-end"
  ],
  components: {
    Row,
    Button,
    MaxRacingNumber
  },
  computed: {
    carIndicatorStyle() {
      return {
        width: "25px",
        height: "25px",
        background: "#112b45",
        position: "absolute",
        display: "inline-block",
        left: "1%",
        top: "3px",
        "border-radius": "25px",
        "font-weight": "bold",
        display: "none"
      };
    },
    sumChampionRunnerup() {
      return parseInt(this.winners[0]) + parseInt(this.winners[1]);
    },
    snakeCaseTitle() {
      return snakeCase(this.game);
    },
    champBS() {
      if (this.drawResult.c_bs == 2) return this.$t("general.Big");
      else return this.$t("general.Small");
    },
    champOE() {
      if (this.drawResult.c_oe == 4) return this.$t("general.Odd");
      else return this.$t("general.Even");
    },
    champRunBS() {
      if (this.drawResult.cru_bs == 6) return this.$t("general.Big");
      else if (this.drawResult.cru_bs == 7) return this.$t("general.Small");
      else return "/";
    },
    champRunOE() {
      if (this.drawResult.cru_oe == 8) return this.$t("general.Odd");
      else if (this.drawResult.cru_bs == 9) return this.$t("general.Even");
      else return "/";
    },
    group() {
      if (this.drawResult.group == 10) return "G1";
      else if (this.drawResult.group == 11) return "G2";
      else if (this.drawResult.group == 12) return "G3";
      else if (this.drawResult.group == 13) return "G4";
      else if (this.drawResult.group == 14) return "G5";
    }
  },
  data() {
    return {
      isAnimationRunning: false,
      stopAnimation: false,
      displayStopAnimationSection: false,
      winners: [],
      isNegative: 0,
      screenWidth: 0,
      currWidth: 0,
      car1: 0,
      racingCountdown: 3
    };
  },
  watch: {
    showDrawingAnimation(newVal, oldVal) {
      if (newVal) {
        this.isAnimationRunning = true;
      }
    },
    drawResult(oldVal, newVal) {
      clearStakeRecord(this.gameData.gID);
      EventBus.$emit("update-session-storage");

      let vm = this;

      // if (newVal) {
      if (newVal && this.isAnimationRunning) {
        this.racingCountdown = 3;
        this.screenWidth = this.$refs["max-racing-game"].clientWidth;

        //Start road image animation

        this.currWidth =
          Math.abs((this.$refs["max-racing-game"].clientWidth / 10) * 8) * -1;

        //Animation Section appear
        let animationTl = new TimelineLite();
        animationTl.set(vm.$refs["animation-section"], {
          display: "flex",
          opacity: 1
        });

        //Black background on behind appear
        TweenLite.set(vm.$refs["max-racing-dark-bg"], {
          display: "flex",
          opacity: 1
        });

        // Display Countdown
        TweenMax.set(vm.$refs["racing-countdown"], {
          display: "block"
        });
        let interval = setInterval(() => {
          this.racingCountdown -= 1;

          if (this.racingCountdown <= 1) {
            clearInterval(interval);
          }
        }, 1000);

        TweenMax.to(this.$refs["roadMove"], 1, {
          x: 320,
          ease: Linear.easeNone,
          repeat: 6,
          delay: 3
        });

        this.winners = this.drawResult.champion.split(",");

        let distanceAry = [];

        let distance1 = this.get1stRandNeInt();

        let distance2 = this.get2ndRandNeInt();

        let distance3 = this.get3rdRandNeInt();

        let distance4 = this.get4thRandNeInt();

        let distance5 = this.get5thRandNeInt();

        let distance6 = this.get6thRandNeInt();

        let distance7 = this.get7thRandNeInt();

        let distance8 = this.get8thRandNeInt();

        let distance9 = this.get9thRandNeInt();

        let distance10 = this.get10thRandNeInt();
        distanceAry.push(
          distance1,
          distance2,
          distance3,
          distance4,
          distance5,
          distance6,
          distance7,
          distance8,
          distance9,
          distance10
        );

        for (var x = 0; x < this.winners.length; x++) {
          let vm = this;
          let carNumber = "car" + this.winners[x];
          let time = 1.25;
          let normalDistance = 0;
          normalDistance = this.getRandInt();

          // CountDown
          TweenMax.set(vm.$refs["racing-countdown"], {
            display: "none",
            delay: 3
          });
          let carRacing = new TimelineLite();

          carRacing
            .to(this.$refs[carNumber], time, {
              x: this.currWidth / 10,
              delay: 3
            })
            .to(vm.$refs[carNumber], 3, { x: normalDistance })
            .to(vm.$refs[carNumber], 3, {
              x: distanceAry[x]
            })
            .to(vm.$refs[carNumber], 5, {
              x: -900,
              onComplete: function() {
                // Clear car animation
                TweenLite.set(vm.$refs[carNumber], {
                  clearProps: "all"
                });
              }
            });

          // Show champion indicator
          TweenLite.set(vm.$refs[`car-indicator-${x + 1}`], {
            display: "inline-block",
            delay: 11
          });
          // }
          // Highlight indicator Gold, Silver, Bronze
          if (x == 0 || x == 1 || x == 2) {
            vm.indicatorChange(this.winners[x], x);
          }

          // Indicate winners
          let changeName = "indicator-" + this.convertNum(this.winners[x]);
          let innertext = x + 1;

          vm.$refs[`${changeName}`].innerHTML = innertext;
        }

        // Hide everything etc.
        let clearAnimationTL = new TimelineLite({ delay: 14 });
        clearAnimationTL.set(vm.$refs["animation-section"], {
          display: "none"
        });

        // Show result
        let newAnimationTL = new TimelineLite({ delay: 14 });
        newAnimationTL.set(vm.$refs["animation-section-result"], {
          display: "flex",
          opacity: 1,
          onComplete: function() {
            //Clear animation
            TweenLite.set(vm.$refs["roadMove"], {
              clearProps: "all"
            });
            for (var z = 1; z <= 10; z++) {
              let changingIndicator = "indicator-" + vm.convertNum(z);
              TweenLite.set(vm.$refs[`car-indicator-${z}`], {
                display: "none"
              });
              vm.$refs[changingIndicator].style.border = "1px solid #112b45";

              vm.$refs[changingIndicator].style.color = "#2a5581";
            }
          }
        });

        // Hide animation section
        let closeAnimationTL = new TimelineLite({ delay: 17 });
        closeAnimationTL.set(vm.$refs["animation-section-result"], {
          display: "none",
          onComplete: function() {
            // End animation
            vm.isAnimationRunning = false;
            vm.animationEnd();
          }
        });

        // Hide dark background
        let closeAnimationBg = new TimelineLite({ delay: 17 });
        closeAnimationBg.set(vm.$refs["max-racing-dark-bg"], {
          display: "none"
        });
      }
    }
  },
  methods: {
    get1stRandNeInt() {
      return Math.floor(this.currWidth + 120);
    },
    get2ndRandNeInt() {
      return Math.floor(this.currWidth + random(130, 140));
    },
    get3rdRandNeInt() {
      return Math.floor(this.currWidth + random(150, 160));
    },
    get4thRandNeInt() {
      return Math.floor(this.currWidth + random(170, 180));
    },
    get5thRandNeInt() {
      return Math.floor(this.currWidth + random(190, 200));
    },
    get6thRandNeInt() {
      return Math.floor(this.currWidth + random(210, 220));
    },
    get7thRandNeInt() {
      return Math.floor(this.currWidth + random(230, 240));
    },
    get8thRandNeInt() {
      return Math.floor(this.currWidth + random(250, 260));
    },
    get9thRandNeInt() {
      return Math.floor(this.currWidth + random(270, 280));
    },
    get10thRandNeInt() {
      return Math.floor(this.currWidth + random(290, 300));
    },

    getRandInt() {
      return Math.floor(
        Math.random() * (this.screenWidth / 2) - this.screenWidth / 2
      );
    },
    // clearProps() {
    //   let vm = this;
    //   for (var z = 1; z <= 10; z++) {
    //     let carNumber = "car" + z;
    //     let changingIndicator = "indicator-" + this.convertNum(z);
    //     TweenLite.set(this.$refs[carNumber], {
    //       clearPropsx: "all",
    //       onComplete: () => {
    //         for (var z = 1; z <= 10; z++) {
    //           TweenLite.set(vm.$refs[`car-indicator-${z}`], {
    //             display: "none"
    //           });
    //         }

    //         this.$refs[changingIndicator].style.border = "1px solid #112b45";

    //         this.$refs[changingIndicator].style.color = "#2a5581";
    //       }
    //     });
    //   }
    // },
    indicatorChange(num, val) {
      let changingIndicator = "indicator-" + this.convertNum(num);

      if (val == 0) {
        this.$refs[changingIndicator].style.border = "1px solid #ffd445";
        this.$refs[changingIndicator].style.color = "#ffd445";
      }
      if (val == 1) {
        this.$refs[changingIndicator].style.border = "1px solid #cccccc";
        this.$refs[changingIndicator].style.color = "#cccccc";
      }
      if (val == 2) {
        this.$refs[changingIndicator].style.border = "1px solid #ff9e57";
        this.$refs[changingIndicator].style.color = "#ff9e57";
      }
    },
    animationEnd() {
      this.$emit("on-animation-end");
    },
    convertNum(val) {
      return val == 1
        ? "one"
        : val == 2
        ? "two"
        : val == 3
        ? "three"
        : val == 4
        ? "four"
        : val == 5
        ? "five"
        : val == 6
        ? "six"
        : val == 7
        ? "seven"
        : val == 8
        ? "eight"
        : val == 9
        ? "nine"
        : val == 10
        ? "ten"
        : "";
    }
  },
  mounted() {
    EventBus.$emit("update-session-storage");
  }
};
</script>

<style lang="scss" scoped>
.max-racing-game {
  position: relative;
  background: #ffffff;
  background-size: cover;
  background-position: top;
  height: 373px;
}

.roadImg {
  right: 0;
  bottom: 0;
  width: 300%;
  height: 310px;
  position: absolute;
}

.roadMove {
  // animation-name: roadMoveplaybox;
  animation-delay: 0ms;
  animation-duration: 600ms;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

.animation-wrapper {
  width: 100%;
  position: relative;
  text-align: center;
}

.race-track-two,
.race-track-six,
.race-track-seven,
.race-track-eight,
.race-track-ten {
  width: 100%;
  height: 31px;
  // background: #16324e;
  background: transparent;
  display: block;
  position: relative;
  // border-bottom: 0.5px dashed white;
  overflow: hidden;
}

.race-track-one,
.race-track-three,
.race-track-five,
.race-track-nine {
  width: 100%;
  height: 31px;
  background: transparent;
  display: block;
  position: relative;
  // border-bottom: 0.5px dashed white;
  overflow: hidden;
}

.race-track-four {
  width: 100%;
  height: 31px;
  // background: linear-gradient(
  //   to right,
  //   rgba(21, 54, 88, 0) -2%,
  //   rgba(255, 196, 0, 0.31) 100%
  // );
  background: transparent;
  display: block;
  position: relative;
  // border-bottom: 0.5px dashed white;
  overflow: hidden;
}

.car-wrap {
  width: 100%;
  height: 27px;
  position: relative;
}

.car {
  width: auto;
  height: 25px;
  // right: -80px;
  right: 0;
  top: 4px;
  position: absolute;
}

// .car-indicator {
//   width: 25px;
//   height: 25px;
//   background: #112b45;
//   position: absolute;
//   display: inline-block;
//   left: 1%;
//   top: 3px;
//   border-radius: 25px;
//   font-weight: bold;
//   display: none;
// }

.indicator-number {
  position: absolute;
  width: 19px;
  height: 19px;
  left: 12%;
  top: 3px;
  line-height: 18px;
  border-radius: 19px;
  font-size: 10px;
  color: #2a5581;
}

.max-racing-animation-section,
.max-racing-animation-section-result {
  display: none;
  position: absolute;
  left: 10%;
  top: 10%;
  width: 80%;
  height: 310px;
  overflow: hidden;
  // background: rgba(#000000, 0.9);
  // background: url("https://i.ibb.co/FH9MV9z/roadv6.png");
  background-size: cover;
}

.max-racing-animation-section-result {
  background: url("../../assets/images/max-racing/popover-bg.png");
}

.max-racing-animation-section.hide,
.max-racing-animation-section-result.hide {
  display: none;
}

.section-result-wrapper {
  width: 100%;
}

.animation-result-title {
  width: 100%;
  text-align: center;
  padding-top: 18px;
  font-weight: 500;
  color: #fff;
  font-size: 14px;
}

.rounds-wrapper {
  width: 100%;
  padding: 8px;
  text-align: center;
  display: flex;
  justify-content: space-around;
  padding: 8px 25px;
}

.rounds {
  width: 22px;
  height: 22px;
  border-radius: 19px;
  background: #254a83;
  display: inline-block;
  border: 2px solid #112f4d;
  text-align: center;
  color: #fff;
  font-size: 11px;
  line-height: 19px;
  position: relative;
}

.star-image {
  position: absolute;
  top: -5px;
}

.trophy-wrapper {
  text-align: center;
  height: 130px;
}

.champion-car {
  position: relative;
  display: inline-block;
  top: -36px;
  left: -18px;
  color: #ffad29;
  font-size: 16px;
}

.runnerup-car {
  position: relative;
  display: inline-block;
  top: -34px;
  right: -18px;
  color: #afafaf;
  font-size: 16px;
}
.test {
  right: 28px;
  position: absolute;
  width: 15px;
  height: 15px;
  background: transparent;
  /* content: "1"; */
  line-height: 12px;
  border-radius: 15px;
  border: 2px solid black;
  color: aliceblue;
  top: 8px;
  font-size: 10px;
}
.champion-result-container {
  text-align: center;
  width: 80%;
  background: #112f4d;
  position: relative;
  left: 10%;
  height: 39px;
  display: block;
  text-align: right;
}

.champion-runner-result-container {
  margin-top: 10px;
  text-align: center;
  width: 80%;
  background: #112f4d;
  position: relative;
  left: 10%;
  height: 39px;
  display: block;
  text-align: right;
}

.champion-result {
  text-align: center;
  background: #102a45;
  display: inline-block;
  height: 27px;
  top: 6px;
  width: 34%;
  color: white;
  font-size: 12px;
  line-height: 27px;
  border-radius: 3px;
  margin-top: 6px;
  margin-right: 6px;
}

.champion-result-number {
  display: inline-block;
  height: 27px;
  display: inline-block;
  height: 27px;
  top: 6px;
  width: 6%;
  margin-top: 6px;
  margin-right: 6px;
  color: #d4af37;
  font-size: 16px;
  line-height: 27px;
  border-radius: 3px;
  text-align: center;
  font-weight: 900;
  margin-left: 5px;
}

.trophy-result-image {
  text-align: center;
  display: inline-block;
  width: 26px;
  height: 26px;
  position: relative;
  left: 0;
  top: 5px;
}

.champion-result-image {
  // position: absolute;
}

.champion-runner-result {
  text-align: center;
  background: #102a45;
  display: inline-block;
  height: 27px;
  top: 6px;
  width: 22%;
  color: white;
  font-size: 12px;
  line-height: 27px;
  border-radius: 3px;
  right: 6px;
  margin-top: 6px;
  margin-right: 6px;
}

.max-racing-disallow-betting-section {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: white;
  background: rgba(#000000, 0.9);
  font-size: 16px;
  z-index: 100;
}
.max-racing-disallow-betting-section {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: white;
  background: rgba(#000000, 0.9);
  font-size: 16px;
  z-index: 100;
}

.max-racing-dark-bg {
  position: absolute;
  display: none;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: white;
  background: rgba(#000000, 0.9);
  font-size: 16px;
}

.max-racing-stop-animation-section.show {
  display: block;
}

.max-racing-disallow-betting,
.max-racing-stop-animation {
  width: 100%;
  height: 100%;
  z-index: 110;
}

.max-racing-animation-banner-container {
  display: none;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding: 0 20px;
  z-index: 1;
}

.max-racing-game-animation-next-draw {
  background-color: $tai-xiu-theme-color-13;
  color: $tai-xiu-theme-color-5;
  border-radius: 6px;
  font-size: 14px;
  margin-right: 5px;
  padding: 4px 20px;
  font-weight: bolder;
  z-index: 1;
}

.max-racing-game-animation-next-draw-section {
  position: absolute;
  top: 20px;
  width: 100%;
}

.max-racing-animation-inner {
  position: relative;
  width: 100%;
}

.max-racing-animation-banner-inner {
  height: 100%;
}
.racing-countdown {
  position: absolute;
  color: white;
  left: 50%;
  top: 35%;
  font-size: 50px;
  display: none;
}
</style>
